export default function handleVersion(availableVersion) {
  const currentVersion = localStorage.getItem('current_version') || true;
  const isNewVersion = currentVersion && availableVersion && currentVersion !== availableVersion;

  if (!isNewVersion) return;

  console.info(
    `newer version available (current: ${currentVersion}, available: ${availableVersion}`,
  );

  localStorage.setItem('current_version', availableVersion);

  const urlParams = window.location.search.substring(1).split('&');
  const shouldReload = !urlParams.find(param => param.includes('_='));

  if (shouldReload) {
    window.location = `${window.location}/?_=${Date.now()}`;
  }
}

export const readVersion = () => {
  return localStorage.getItem('current_version');
};



// WEBPACK FOOTER //
// ../utils/functions/version-handler.js